import React from 'react';
import PropTypes from 'prop-types';
// import Questions from './Questions';
// import Definitions from './Definitions';
// import Recycle from './Recycle';
// import Geographies from './Geographies';
import DynamicTabs from '../common/DynamicTabs';
// import Questions from '../common/Questions';
import GeographiesV2 from './GeographiesV2';
import DefinitionsV2 from './DefinitionsV2';
import Recycle from '../common/Recycle';
import QuestionsV2 from './QuestionsV2';

const ProfileTabsV2 = ({
  handleAnswersPreview,
  handleSelectedKeywords,
  moveAppendToCodingBox,
  selectedModule,
  moduleStudy,
  gridData,
  trackerFn,
  moduleWeigthType,
  noExpressionBox,
  moduleColumns,
  moduleRows,
  moduleAction,
  rightGridList,
  dictionaryTabsList,
  functionProbabilitiesFlag,
  breadcrumbFlag,
  refreshFlag,
  rowColBaseGrid,
  isSingleBase,
  useQuestions,
  partsToShow,
}) => {
  const tabs = [];
  if (dictionaryTabsList.includes('dictionary')) {
    tabs.push({
      title: 'Dictionary',
      content: (
        <QuestionsV2
          handleAnswersPreview={handleAnswersPreview}
          handleSelectedKeywords={handleSelectedKeywords}
          moveAppendToCodingBox={moveAppendToCodingBox}
          selectedModule={selectedModule}
          moduleStudy={moduleStudy}
          gridData={gridData}
          trackerFn={trackerFn}
          moduleWeigthType={moduleWeigthType}
          noExpressionBox={noExpressionBox}
          moduleColumns={moduleColumns}
          moduleRows={moduleRows}
          moduleAction={moduleAction}
          rightGridList={rightGridList}
          functionProbabilitiesFlag={functionProbabilitiesFlag}
          breadcrumbFlag={breadcrumbFlag}
          refreshFlag={refreshFlag}
          rowColBaseGrid={rowColBaseGrid}
          isSingleBase={isSingleBase}
          useQuestions={useQuestions}
          partsToShow={partsToShow}
        />
      ),
    });
  }

  if (dictionaryTabsList.includes('geography')) {
    tabs.push({
      title: 'Geographies',
      content: (
        <GeographiesV2
          selectedModule={selectedModule}
          moduleStudy={moduleStudy}
          noExpressionBox={noExpressionBox}
          breadcrumbFlag={breadcrumbFlag}
          refreshFlag={refreshFlag}
        />
      ),
    });
  }

  if (dictionaryTabsList.includes('definition')) {
    tabs.push({
      title: 'Definitions',
      content: (
        <DefinitionsV2
          handleAnswersPreview={handleAnswersPreview}
          handleSelectedKeywords={handleSelectedKeywords}
          moveAppendToCodingBox={moveAppendToCodingBox}
          moduleStudy={moduleStudy}
          noExpressionBox={noExpressionBox}
          breadcrumbFlag={breadcrumbFlag}
          refreshFlag={refreshFlag}
        />
      ),
    });
  }

  if (dictionaryTabsList.includes('recycle')) {
    tabs.push({
      title: 'Recycle',
      content: (
        <Recycle
          handleAnswersPreview={handleAnswersPreview}
          handleSelectedKeywords={handleSelectedKeywords}
          moveAppendToCodingBox={moveAppendToCodingBox}
          gridData={gridData}
          noExpressionBox={noExpressionBox}
          breadcrumbFlag={breadcrumbFlag}
        />
      ),
    });
  }

  return (
    <div>
      <DynamicTabs
        tabs={tabs}
        moduleStudy={moduleStudy}
      />
    </div>);
};

ProfileTabsV2.propTypes = {
  handleAnswersPreview: PropTypes.func,
  handleSelectedKeywords: PropTypes.func,
  moveAppendToCodingBox: PropTypes.func,
  selectedModule: PropTypes.string,
  moduleStudy: PropTypes.shape({}),
  gridData: PropTypes.shape({}),
  trackerFn: PropTypes.func,
  moduleWeigthType: PropTypes.shape({}),
  noExpressionBox: PropTypes.bool,
  moduleAction: PropTypes.shape({}),
  moduleColumns: PropTypes.arrayOf(PropTypes.object),
  moduleRows: PropTypes.arrayOf(PropTypes.object),
  rightGridList: PropTypes.arrayOf(PropTypes.string),
  dictionaryTabsList: PropTypes.arrayOf(PropTypes.string),
  functionProbabilitiesFlag: PropTypes.bool,
  breadcrumbFlag: PropTypes.bool,
  refreshFlag: PropTypes.bool,
  rowColBaseGrid: PropTypes.bool,
  isSingleBase: PropTypes.bool,
  useQuestions: PropTypes.bool,
  partsToShow: PropTypes.shape({}),
};

export default ProfileTabsV2;
